import { useState, useEffect, useRef } from "react";
import { GetUser } from "../Services";
import userImage from "../uploads/assets/user2.png";
import car1 from "../uploads/assets/car7.png";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const TrackUsers = () => {
  const [inputValue, setInputValue] = useState("");
  const [selectedButton, setSelectedButton] = useState("All");
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  const wsRef = useRef(null); // store websocket connection

  const center = {
    lat: 9.0108,
    lng: 38.7613,
  };

  const { isLoaded: googleMapsLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAbJIqSfbwgfz4NfYdcGQNEc-d01WeSKgw",
    libraries: ["places"],
  });

  // 🚀 1. Load drivers initially
  // useEffect(() => {
  //   const fetchDrivers = async () => {
  //     setLoading(true);
  //     try {
  //       const data = await GetUser.fetchDriverList();
  //       setDrivers(Array.isArray(data.drivers) ? data.drivers : []);
  //     } catch (error) {
  //       console.error("Error fetching drivers:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchDrivers();
  // }, []);

  // 🚀 2. Setup WebSocket for realtime updates
  useEffect(() => {
    const ws = new WebSocket("ws://localhost:8080");
    wsRef.current = ws;

    ws.onopen = () => {
      console.log("Connected to WebSocket server.");
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);

      console.log("Live driver data: ", data);

      if (data.type === "driverList") {
        // Initial list from server
        const formattedDrivers = Object.entries(data.drivers).map(
          ([id, loc]) => ({
            id,
            name: `Driver ${id}`,
            phone_number: "Unknown",
            latitude: loc.latitude,
            longitude: loc.longitude,
          })
        );
        setDrivers(formattedDrivers);

        console.log("drivers: ", drivers);
      }

      if (data.type === "driverAdded") {
        const newDriver = {
          id: data.driver.id,
          name: `Driver ${data.driver.id}`,
          phone_number: "Unknown",
          latitude: data.driver.latitude,
          longitude: data.driver.longitude,
        };
        setDrivers((prev) => {
          // avoid duplicates
          if (prev.some((d) => d.id === newDriver.id)) return prev;
          return [...prev, newDriver];
        });
      }

      if (data.type === "driverRemoved") {
        setDrivers((prev) => prev.filter((d) => d.id !== data.driverId));
      }
    };

    ws.onclose = () => {
      console.log("WebSocket connection closed.");
    };

    return () => {
      ws.close();
    };
  }, []);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName);
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h2 className="text-2xl font-bold">Track Users</h2>
        </div>

        <div className="card">
          <div className="card-body">
            {/* Filter Buttons */}
            <div
              className="d-flex flex-row gap-2 mb-4"
              style={{ maxWidth: "30%" }}
            >
              {["All", "Available", "Ride Started", "Reached Pickup"].map(
                (label) => (
                  <button
                    key={label}
                    type="button"
                    className={`btn ml-4 ${
                      selectedButton === label
                        ? "btn-primary text-white"
                        : "btn-outline-primary"
                    }`}
                    onClick={() => handleButtonClick(label)}
                  >
                    {label}
                  </button>
                )
              )}
            </div>

            {/* Two Columns */}
            <div className="row">
              {/* Left Column */}
              <div className="col-md-4" style={{ flex: "0 0 30%" }}>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Enter Driver Name"
                  value={inputValue}
                  onChange={handleInputChange}
                />

                <div
                  className="border rounded p-3"
                  style={{ height: "450px", overflowY: "auto" }}
                >
                  {drivers.map((user, index) => (
                    <div
                      key={index}
                      className="border rounded p-3 d-flex align-items-start mb-3"
                      style={{ height: "100px" }}
                    >
                      <img
                        src={userImage}
                        alt={user.name}
                        style={{
                          width: "80px",
                          height: "80px",
                          marginRight: "10px",
                        }}
                      />
                      <div style={{ flexDirection: "column" }}>
                        <div style={{ fontWeight: "bold", fontSize: "1.2em" }}>
                          {user.name}
                        </div>
                        <div style={{ fontSize: "1em", color: "#555" }}>
                          {user.phone_number}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Column (Map) */}
              <div className="col-md-8" style={{ flex: "0 0 70%" }}>
                <div
                  className="border rounded"
                  style={{ height: "400px", backgroundColor: "#e9ecef" }}
                >
                  {googleMapsLoaded && (
                    <GoogleMap
                      mapContainerStyle={{
                        width: "100%",
                        height: "125%",
                        border: "0.5px solid #51657bff",
                        borderRadius: "8px",
                      }}
                      center={center}
                      zoom={13}
                    >
                      {drivers.map((driver) => (
                        <Marker
                          key={driver.id}
                          position={{
                            lat: driver.latitude || center.lat,
                            lng: driver.longitude || center.lng,
                          }}
                          icon={{
                            url: car1,
                            scaledSize: new window.google.maps.Size(40, 40),
                          }}
                        />
                      ))}
                    </GoogleMap>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackUsers;
